import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 23rem;
  height: 4.25rem;
  align-items: center;

  margin-top: 1rem;

  border: 1.41135px solid #d4d6da;
  box-sizing: border-box;
  border-radius: 8.46812px;
`;

export const AttachmentData = styled.div`
  margin-left: 0.8rem;
  display: flex;
  align-items: center;
  width: 75%;
`;

export const DocIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.6rem;
  background-color: #d4d6da;
`;

export const AttachmentNameAndSize = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.2rem;
  width: 70%;
`;

export const AttachmentName = styled.span`
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #212326;
`;

export const AttachmentSize = styled.div`
  font-size: 0.74rem;
  line-height: 0.96rem;
  color: #7e858f;
`;

export const AttachmentDownload = styled.a`
  display: flex;
`;

export const IconButtons = styled.div`
  display: flex;
  width: 15%;
  margin-right: 0.8rem;
  justify-content: space-around;
`;
